import { NavigationItem } from '../@vex/interfaces/navigation-item.interface';

export const appNavigationConfig: NavigationItem[] = [
	{
		type: 'link',
		label: 'MAINMENU.DASHBOARD',
		route: '/home',
		iconName: 'home',
		routerLinkActiveOptions: { exact: true },
	},
	{
		type: 'link',
		label: 'MAINMENU.CORONA_TOOLS',
		hide: true,
		route: '/corona',
		iconName: 'coronavirus',
		routerLinkActiveOptions: { exact: true },
	},
	{
		type: 'link',
		label: 'MAINMENU.TEAMCALENDAR',
		route: '/teamcalendar',
		iconName: 'calendar_month',
		routerLinkActiveOptions: { exact: true },
	},
	{
		type: 'link',
		label: 'MAINMENU.FAMILY',
		route: '/family',
		icon: null,
		iconName: 'hot_tub',
		routerLinkActiveOptions: { exact: true },
	},
	{
		type: 'link',
		label: 'MAINMENU.SKILLS',
		route: '/skills',
		icon: null,
		iconName: 'school',
		routerLinkActiveOptions: { exact: true },
	},
	{
		type: 'link',
		label: 'MAINMENU.CUSTOMERS',
		route: '/customers',
		icon: null,
		iconName: 'recent_actors',
		routerLinkActiveOptions: { exact: true },
	},
	{
		type: 'link',
		label: 'MAINMENU.PROJECTS',
		route: '/projects',
		icon: null,
		iconName: 'playlist_add_check',
		routerLinkActiveOptions: { exact: true },
	},
	{
		type: 'link',
		label: 'MAINMENU.TEAMS',
		route: '/teams',
		icon: null,
		iconName: 'groups',
		routerLinkActiveOptions: { exact: true },
	},
	{
		type: 'link',
		hide: true,
		label: 'MAINMENU.PROFILE',
		route: '/profile',
		icon: null,
		iconName: 'contact_mail',
		routerLinkActiveOptions: { exact: true },
	},
	{
		type: 'link',
		label: 'MAINMENU.LIST_OF_LINKS',
		route: '/list-of-links',
		icon: null,
		iconName: 'share',
		routerLinkActiveOptions: { exact: true },
	},
	{
		type: 'link',
		label: 'MAINMENU.PROCESS_MANUAL',
		route: '/process-manual',
		//link: 'https://it-objects.atlassian.net/wiki/spaces/ITO/pages/463273985/Processes+Guidelines',
		icon: null,
		iconName: 'memory',
		routerLinkActiveOptions: { exact: true },
	},
	{
		type: 'link',
		label: 'MAINMENU.EVENTS',
		route: '/events',
		icon: null,
		iconName: 'event_available',
		routerLinkActiveOptions: { exact: true },
	},
	{
		type: 'link',
		label: 'MAINMENU.MEETUPS',
		route: '/meetups',
		icon: null,
		iconName: 'co_present',
		routerLinkActiveOptions: { exact: true },
	},
	{
		type: 'link',
		label: 'MAINMENU.KARMA_POINTS',
		route: '/karma',
		icon: null,
		iconName: 'military_tech',
		routerLinkActiveOptions: { exact: true },
	},	
	{
		type: 'link',
		label: 'MAINMENU.ITO_GPT',
		link: 'https://chat.it-objects.de/',
		icon: null,
		iconName: 'smart_toy',
		routerLinkActiveOptions: { exact: true },
	},
	{
		//type: 'dropdown',
		type: 'subheading',
		label: 'MAINMENU.R18.TITLE',
		//icon: null,
		//iconName: 'maps_home_work',
		children: [
			{
				type: 'link',
				label: 'MAINMENU.R18.BUERO_INFOS',
				route: '/r18/buero-infos',
				icon: null,
				iconName: 'villa',
			},
			{
				type: 'link',
				label: 'MAINMENU.R18.KAFFEBAR',
				route: '/r18/kaffeebar',
				icon: null,
				iconName: 'coffee',
			},
			{
				type: 'link',
				label: 'MAINMENU.R18.LUNCHBOX',
				route: '/r18/lunchbox',
				icon: null,
				iconName: 'lunch_dining',
			},
			{
				type: 'link',
				label: 'MAINMENU.R18.DOCUMENTS',
				route: '/r18/documents',
				icon: null,
				hide: true,
				iconName: 'feed',
			},
			{
				type: 'link',
				label: 'Chez Guido',
				route: '/r18/kantine',
				icon: null,
				iconName: 'restaurant',
			},
		],
	},
	/*
  {
    type: 'link',
    label: 'Admin',
    route: '/admin',
    icon: null,
    iconName: 'admin_panel_settings',
    routerLinkActiveOptions: { exact: true }
  },
  */
];
